<div
  class="filter-item"
  [matMenuTriggerFor]="desktopMoreFilters"
  #trigger="matMenuTrigger"
  [ngClass]="{ active: isActive || isOpen }"
  (menuOpened)="isOpen = true"
  (menuClosed)="isOpen = false"
  (onMenuClose)="handleReset(false)"
>
  <span
    >More filters
    <span *ngIf="checkedCount > 0">({{ checkedCount }})</span></span
  >
  <app-shared-icon name="chevron-down-2"></app-shared-icon>
</div>

<mat-menu
  #desktopMoreFilters="matMenu"
  xPosition="after"
  class="filters-mat-menu"
>
  <div
    class="filter-dropdown lg filter-more-desktop-content"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    <app-filter-v2-beds></app-filter-v2-beds>
    <app-filter-v2-baths></app-filter-v2-baths>
    <app-filter-v2-sqft></app-filter-v2-sqft>
    <app-filter-v2-lot-size></app-filter-v2-lot-size>
    <app-filter-v2-year-built></app-filter-v2-year-built>

    <app-filter-v2-buttons
      position="right"
      (resetAction)="handleReset()"
      (applyAction)="handleApply()"
    ></app-filter-v2-buttons>
  </div>
</mat-menu>
